<template>
  <div class="pa-5">
    <v-card shaped class="elevation-10">
      <v-card-title>
        <div>รายการข่าวสาร</div>
        <v-spacer></v-spacer>
        <v-btn color="success" to="/news/create">เขียนข่าว</v-btn>
      </v-card-title>
      <v-card-text class="py-0">        
        <v-text-field v-model="term" dense solo prepend-inner-icon="mdi-magnify" label="ค้นหา" @input="searchChange"></v-text-field>
      </v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th style="width: 15%;">รูปภาพหน้าปก</th>
              <th style="width: 15%;">ประเภทข่าว</th>
              <th style="width: 65%;">หัวข้อข่าว</th>
              <th style="width: 5%;"></th>
            </tr>
          </thead>
          <tbody v-if="news && news.data && news.data.length > 0">
            <tr v-for="item in news.data" :key="item.id">
              <td>
                <v-img 
                  v-if="item.cover_path"
                  class="my-4"
                  :src="`https://www.srru.ac.th/personnel/storage/news/images/covers/${item.cover_path}`"
                  max-width="150"
                ></v-img>
                <v-subheader v-else>-</v-subheader>
              </td>
              <td class="text-truncate">{{ item.news_type.name_th }}</td>
              <td>{{ item.headline_th }}</td>
              <td>
                <v-menu offset-y transition="fade-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-on="on" v-bind="attrs"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-if="item.news_type_id == 2" :to="`/news/${item.id}/announcement`">
                      <v-list-item-icon><v-icon>mdi-bullhorn</v-icon></v-list-item-icon>
                      <v-list-item-title>ประกาศผล</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="`/news/${item.id}/edit`">
                      <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
                      <v-list-item-title>แก้ไข</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="confirmDeleteNews(item.id)">
                      <v-list-item-icon><v-icon>mdi-delete</v-icon></v-list-item-icon>
                      <v-list-item-title>ลบ</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <v-subheader>---ไม่พบข่าวสารในระบบ---</v-subheader>
          </tbody>
        </template>
      </v-simple-table>
      <v-pagination
        class="pb-5"
        v-model="page"
        :length="news.last_page"
        @input="selectPage"
      ></v-pagination>
    </v-card>
    <v-dialog v-model="confirm_delete" max-width="500">
      <v-card>
        <v-card-title>ยืนยันการลบข่าวสาร</v-card-title>
        <v-card-text>คุณต้องการลบข่าวสารนี้ใช่หรือไม่</v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="deleteNews()">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  data: () => ({
    page: 1,
    term: '',
    news: [],
    confirm_delete: false
  }),
  created() {
    this.getNews('', '', this.page);
  },
  methods: {
    getNews(term, type, page) {
      this.$store.dispatch('news/list', {
        term: term,
        type: type,
        page: page
      }).then(data => this.news = data);
    },
    deleteNews() {
      this.$store.dispatch('news/delete', this.delete_selected).then(() => {
        this.confirm_delete = false;
        this.getNews('', '', 1);
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'ลบข้อมูลสำเร็จ'
        });
      });
    },
    confirmDeleteNews(id) {
      this.confirm_delete = true;
      this.delete_selected = id;
    },
    selectPage(e) {
      this.page = e;
      this.getNews(this.term, '', e);
    },
    searchChange: _.debounce(function(e) {
      this.page = 1;
			this.getNews(e, '', 1);
		}, 500),
  }
}
</script>